import { rootApi } from "../../api/rootApi";

export const banUnbanApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllbanUnban: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/banUnban`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchbanUnbanById: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/banUnban/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    addbanUnban: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/banUnban/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchAllbanUnbanMutation,
  useFetchbanUnbanByIdMutation,
  useAddbanUnbanMutation,
} = banUnbanApi;
